import { RESULTS_ROOT } from 'utils/constants/urls';

import {
  ASYNC_PROGRAMS_QUIZ_IDS,
  QuizIdsEnum as QuizTypes,
} from '../../constants';
import desktopModalImageBv from '../../InitialQuizScreen/images/bv/confirmation-ppq-modal-images.png';
import desktopModalImageCs from '../../InitialQuizScreen/images/cs/confirmation-ppq-modal-images.png';
import desktopModalImageGh from '../../InitialQuizScreen/images/gh/confirmation-ppq-modal-images.png';
import desktopModalImageUti from '../../InitialQuizScreen/images/uti/confirmation-ppq-modal-images.png';
import desktopModalImageYi from '../../InitialQuizScreen/images/yi/confirmation-ppq-modal-images.png';

export function getMobileImageByProgram(quizId: QuizTypes) {
  // desktopModalImageGh is the default image
  let desktopModalImage = desktopModalImageGh;

  switch (quizId) {
    case ASYNC_PROGRAMS_QUIZ_IDS['bv-async']:
      desktopModalImage = desktopModalImageBv;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['cold-sores-async']:
      desktopModalImage = desktopModalImageCs;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['genital-herpes-async']:
      desktopModalImage = desktopModalImageGh;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['yeast-infection-async']:
      desktopModalImage = desktopModalImageYi;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['uti-async']:
    default:
      desktopModalImage = desktopModalImageUti;
  }

  return { desktopModalImage };
}

export function getEligibleContent(quizId: QuizTypes) {
  let eligibleContent = '';
  switch (quizId) {
    case ASYNC_PROGRAMS_QUIZ_IDS['bv-async']:
      eligibleContent = 'bacterial vaginosis (BV)';
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['cold-sores-async']:
      eligibleContent = 'cold sores';
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['genital-herpes-async']:
      eligibleContent = 'genital herpes';
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['yeast-infection-async']:
      eligibleContent = 'yeast infection';
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['uti-async']:
    default:
      eligibleContent = 'urinary tract infection (UTI)';
  }

  return eligibleContent;
}

export function getProgramSession(quizId: QuizTypes) {
  let programSession = `${RESULTS_ROOT}/telehealth/sessions?program=`;
  switch (quizId) {
    case ASYNC_PROGRAMS_QUIZ_IDS['bv-async']:
      programSession = `${programSession}bv-async`;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['cold-sores-async']:
      programSession = `${programSession}cold-sores-async`;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['genital-herpes-async']:
      programSession = `${programSession}genital-herpes-async`;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['yeast-infection-async']:
      programSession = `${programSession}yeast-infection-async`;
      break;
    case ASYNC_PROGRAMS_QUIZ_IDS['uti-async']:
    default:
      programSession = `${programSession}uti-async`;
  }
  return programSession;
}
